import type { ArithmeticWorksheet } from '@mathflat/domain/Worksheet'
import { makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'

// 연산 학습지
export class LegacyArithmeticWorksheet extends DTO {
  id: ArithmeticWorksheet['id']
  type: ArithmeticWorksheet['type']
  title: string
  thumbnail: string

  constructor(data: ArithmeticWorksheet) {
    super()

    this.id = data.id
    this.type = data.type
    this.title = data.title
    this.thumbnail = data.thumbnail
    makeObservable(this, {
      id: observable,
      type: observable,
      title: observable,
      thumbnail: observable,
    })
  }
}
